export default "__VITE_ASSET__jHYqI_DC__"